import React, { useState } from 'react';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap'; // Bootstrap Modal का उपयोग करें

function ClaimBusiness({ businessId, onClaimSuccess, onVerificationSuccess, show, onHide }) {
    const [step, setStep] = useState(1); // 1 for email, 2 for OTP
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });
    const [submitting, setSubmitting] = useState(false);

    const resetState = () => {
        setStep(1);
        setEmail('');
        setOtp('');
        setMessage({ type: '', text: '' });
        setSubmitting(false);
    };

    const handleClaimRequest = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMessage({ type: '', text: '' });

        try {
            // यह मानते हुए कि आपका API राउट /api/providers/{id}/claim है
            const response = await api.post(`/providers/${businessId}/claim`, { email });
            // Call the success callback to show flash message in parent
            if (onClaimSuccess) { 
                onClaimSuccess(response.data.message || 'Verification code sent to your email.');
            }
            setStep(2);
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Failed to start claim process.';
            setMessage({ type: 'danger', text: errorMsg });
        } finally {
            setSubmitting(false);
        }
    };

    const handleVerifyRequest = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMessage({ type: '', text: '' });

        try {
            // यह मानते हुए कि आपका API राउट /api/providers/{id}/verify है
            const response = await api.post(`/providers/${businessId}/verify`, { email, otp });
            if (onVerificationSuccess) {
                onVerificationSuccess(response.data.message || 'Business claimed successfully!');
            }
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Verification failed.';
            setMessage({ type: 'danger', text: errorMsg });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Modal show={show} onHide={onHide} onExited={resetState} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Claim Business Ownership</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {message.text && (
                        <div className={`alert alert-${message.type}`}>{message.text}</div>
                    )}
                    {step === 1 && (
                        <form onSubmit={handleClaimRequest}>
                            <p>Enter your official business email to receive a verification code.</p>
                            <div className="form-group">
                                <label htmlFor="claim-email">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="claim-email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={submitting}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                                <button type="button" className="btn btn-secondary me-2" onClick={onHide}>Close</button>
                                <button type="submit" className="btn btn-primary" disabled={submitting}>
                                    {submitting ? 'Sending...' : 'Send Code'}
                                </button>
                            </div>
                        </form>
                    )}
                    {step === 2 && (
                        <form onSubmit={handleVerifyRequest}>
                            <p>A code was sent to <strong>{email}</strong>. Please enter it below.</p>
                            <div className="form-group">
                                <label htmlFor="otp-code">Verification Code (OTP)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="otp-code"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    required
                                    disabled={submitting}
                                />
                            </div>
                             <div className="d-flex justify-content-end mt-3">
                                <button type="button" className="btn btn-secondary me-2" onClick={onHide}>Close</button>
                                <button type="submit" className="btn btn-primary" disabled={submitting}>
                                    {submitting ? 'Verifying...' : 'Verify & Claim'}
                                </button>
                            </div>
                        </form>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ClaimBusiness;